/**
 * Утилита для форматирования дат
 * TODO: Replace with proper date formatting utility when available
 */
export function dateToLocale(date: Date, options?: Intl.DateTimeFormatOptions): string {
  return date.toLocaleString('ru-RU', options);
}
